import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { ResourceRequestStatus } from '~/types';
import { useMeContext } from '~/modules/me';
import {
  hasEditProjectAndTeamPermission,
  hasResourceAllocationEditPermission
} from '~/modules/projects/resourcing-plan/ResourceRequestChart/components/ResourceRequestChartContent/components/util';
import ResourceRequestChartBanner from '~/modules/resourcing/common/components/ResourceRequestChartBanner/ResourceRequestChartBanner';
import ResourceRequestProposeAllButton from './ResourceRequestProposeAllButton';

const useStyles = makeStyles(theme => ({
  root2: {
    padding: theme.spacing(1, 3, 1, 1.5)
  }
}));

export const ResourceRequestProposeAllChartBanner = ({
  resourceRequests,
  isPsaPraaResourceMatchingEnabled
}) => {
  const me = useMeContext();
  const classes = useStyles();

  const hasPermission = hasResourceAllocationEditPermission(me.permissions);
  const submittedResourceRequestUrisWithMatches = hasPermission
    ? resourceRequests
        .filter(
          resourceRequest =>
            resourceRequest.requestStatus === ResourceRequestStatus.Submitted &&
            resourceRequest.resourceMatches?.length &&
            hasEditProjectAndTeamPermission(resourceRequest, null)
        )
        .map(resourceRequest => ({
          resourceRequest,
          userIds: [resourceRequest.resourceMatches[0].userUri]
        }))
    : [];

  return submittedResourceRequestUrisWithMatches.length > 0 ? (
    <ResourceRequestChartBanner
      messageId={
        isPsaPraaResourceMatchingEnabled
          ? 'resourceRequestChartBanner.delaProposeQuestion2'
          : 'resourceRequestChartBanner.delaProposeQuestion'
      }
      classes={classes}
      isPsaPraaResourceMatchingEnabled={isPsaPraaResourceMatchingEnabled}
    >
      <ResourceRequestProposeAllButton
        submittedResourceRequestUrisWithMatches={
          submittedResourceRequestUrisWithMatches
        }
        isPsaPraaResourceMatchingEnabled={isPsaPraaResourceMatchingEnabled}
      />
    </ResourceRequestChartBanner>
  ) : null;
};

ResourceRequestProposeAllChartBanner.propTypes = {
  resourceRequests: PropTypes.array.isRequired,
  isPsaPraaResourceMatchingEnabled: PropTypes.bool.isRequired
};
export default ResourceRequestProposeAllChartBanner;
